import React, { HTMLAttributes, PropsWithChildren } from 'react';
import type * as CSS from 'csstype';

export default function SkeletonLine({
  children,
  dark,
  height,
  margin,
  width,
  className,
  ...restOfProps
}: PropsWithChildren<{
  dark?: boolean;
}> &
  HTMLAttributes<HTMLDivElement> &
  Pick<CSS.Properties<string | number>, 'height' | 'margin' | 'width'>) {
  return (
    <div
      className={`animate-fade rounded-[0.2em] text-transparent max-w-full transition-all duration-500 ease-out ${
        dark ? 'bg-gray-8' : 'bg-gray-9'
      }${className ? ` ${className}` : ''}`}
      style={{
        height: height ?? (children ? 'auto' : '1.125em'),
        margin: margin ?? '0 0 12px 0',
        width: width ?? '100%',
      }}
      {...restOfProps}
    >
      {children}
    </div>
  );
}
